import React from 'react';
import classNames from 'classnames';
import moment from 'moment/moment';

import css from './RelatedTransactionsSection.css';

const ListingsTransaction = ({intl, start, end, statusClass, statusText, createdAt}) => {
  return (
    <>
      <span className={css.rentalDates}>
        {`${moment(start).format("DD MMM")} - ${moment(end).subtract(1,'days').format("DD MMM")}`}
      </span>
      <span className={classNames(statusClass, css.status)}>
        {`${intl.formatMessage({ id: statusText })} `}
      </span>
      <span className={css.createdDate}>
        {moment(createdAt).format("DD MMM YYYY HH:mm")}
      </span>
    </>
  )
}

export default ListingsTransaction;
